import React from 'react';
import styled from 'styled-components';
import flex from '@/css/module/flex.css';
import { SavedQuery } from '@/types';
import { TrevorIcon } from '@trevor/ui-components';

const STYLES = { marginTop: '0px' };

const WarningBanner = styled.div`
  --h-space: 12px;
  --font-size: 14px;
  --line-height: 21px;

  background-color: #ffdac2;
  display: flex;
  padding: var(--h-space) 20px;
  width: 100%;

  & > svg {
    margin-right: var(--h-space);
  }

  & > div > h3 {
    font-weight: bold;
    font-size: var(--font-size);
    line-height: var(--line-height);
    margin: 0;
  }

  & > div > span {
    display: block;
    font-size: var(--font-size);
    line-height: var(--line-height);
    margin-top: 4px;
  }
`;

const QUANTITY_TO_TEXT_MAP: Record<
  'ONE' | 'FEW',
  { title: string; text: string }
> = {
  ONE: {
    title: 'another query depends',
    text: 'that query',
  },
  FEW: {
    title: 'other queries depend',
    text: 'those queries',
  },
};

export type SaveTypeSelectProps = {
  selectedQueryToReplace: Maybe<SavedQuery>;
  overwriteExisting: boolean;
  onChange: F<React.ChangeEvent>;
  takeFocus: F0;
};

export const SaveTypeSelect: React.FC<SaveTypeSelectProps> = ({
  selectedQueryToReplace,
  overwriteExisting,
  onChange,
  takeFocus,
}) => {
  const dependantQueries = selectedQueryToReplace
    ? [
        ...new Set([
          ...selectedQueryToReplace.dependantQuerySeriesIds,
          ...selectedQueryToReplace.dependantJoinSeriesIds,
        ]),
      ]
    : [];

  const numberOfDependantQueries = dependantQueries.length;
  const warningWordings =
    QUANTITY_TO_TEXT_MAP[numberOfDependantQueries === 1 ? 'ONE' : 'FEW'];

  return (
    <>
      {overwriteExisting && numberOfDependantQueries > 0 && (
        <td
          colSpan={4}
          className={`${flex.alignItemsCenter} padding-bottom-15`}
        >
          <WarningBanner>
            <TrevorIcon name="warning" size="md" $color="#F56200" />
            <div>
              <h3>
                {numberOfDependantQueries} {warningWordings.title} on this query
              </h3>
              <span>
                If you replace it, {warningWordings.text} will be updated too.
                Are you sure you want to proceed?
              </span>
            </div>
          </WarningBanner>
        </td>
      )}
      <td colSpan={4} className={`${flex.alignItemsCenter} padding-bottom-15`}>
        <label className={`${flex.alignItemsCenter} radio-inline`}>
          <input
            type="radio"
            name="overwrite_existing"
            value="new"
            checked={!overwriteExisting}
            onChange={onChange}
            style={STYLES}
            onClick={takeFocus}
          />
          <b>Save new</b>
        </label>
        <label className={`${flex.alignItemsCenter} radio-inline`}>
          <input
            type="radio"
            name="overwrite_existing"
            value="existing"
            checked={overwriteExisting}
            style={STYLES}
            onChange={onChange}
          />
          <b>Replace existing query</b>
        </label>
      </td>
    </>
  );
};
